// extracted by mini-css-extract-plugin
export default {"firstScreen":"style_firstScreen__hJbie","row":"style_row__MATeb","grid":"style_grid__gsQ5Q","btnRow":"style_btnRow__4Sz1O"};